import { render } from "./VerificationTableTemplate.vue?vue&type=template&id=8aafc050"
import script from "./VerificationTableTemplate.vue?vue&type=script&lang=js"
export * from "./VerificationTableTemplate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__